import { z } from 'zod';
import { Dateish } from './common';

// ── Templates (config, por mesa) ────────────────────────────────────────────
export const ChecklistTemplateItemSchema = z.object({
  id: z.number().int(),
  text: z.string(),
  position: z.number().int(),
});
export type ChecklistTemplateItem = z.infer<typeof ChecklistTemplateItemSchema>;

export const ChecklistTemplateSchema = z.object({
  id: z.number().int(),
  deskId: z.number().int(),
  name: z.string(),
  active: z.boolean(),
  position: z.number().int(),
  items: z.array(ChecklistTemplateItemSchema),
});
export type ChecklistTemplate = z.infer<typeof ChecklistTemplateSchema>;

/** Item de GET /checklists — template com o nome da mesa dona. */
export const ChecklistTemplateListItemSchema = ChecklistTemplateSchema.extend({
  deskName: z.string(),
});
export type ChecklistTemplateListItem = z.infer<typeof ChecklistTemplateListItemSchema>;

export const ChecklistTemplateListQuerySchema = z.object({
  desk_id: z.coerce.number().int().positive().optional(),
});
export type ChecklistTemplateListQuery = z.infer<typeof ChecklistTemplateListQuerySchema>;

/** POST cria; PUT substitui os itens pela lista enviada (na ordem). */
export const ChecklistTemplateBodySchema = z.object({
  deskId: z.number().int().positive(),
  name: z.string().min(1),
  active: z.boolean().optional(),
  items: z.array(z.string().min(1)),
});
export type ChecklistTemplateBody = z.infer<typeof ChecklistTemplateBodySchema>;

// ── Instâncias no ticket ────────────────────────────────────────────────────
export const TicketChecklistItemSchema = z.object({
  id: z.number().int(),
  checklistId: z.number().int(),
  text: z.string(),
  position: z.number().int(),
  done: z.boolean(),
  doneBy: z.number().int().nullable(),
  doneAt: Dateish.nullable(),
});
export type TicketChecklistItem = z.infer<typeof TicketChecklistItemSchema>;

export const TicketChecklistSchema = z.object({
  id: z.number().int(),
  ticketNumber: z.number().int(),
  /** proveniência; null = ad-hoc ou template excluído depois */
  templateId: z.number().int().nullable(),
  name: z.string(),
  items: z.array(TicketChecklistItemSchema),
});
export type TicketChecklist = z.infer<typeof TicketChecklistSchema>;

/**
 * POST /tickets/:n/checklists — por template (instancia SNAPSHOT dos itens)
 * OU ad-hoc com nome + itens livres.
 */
export const TicketChecklistAddBodySchema = z.union([
  z.object({ templateId: z.number().int().positive() }).strict(),
  z
    .object({
      name: z.string().min(1),
      items: z.array(z.string().min(1)).min(1),
    })
    .strict(),
]);
export type TicketChecklistAddBody = z.infer<typeof TicketChecklistAddBodySchema>;

/** POST /tickets/checklists/:id/items */
export const TicketChecklistItemAddBodySchema = z.object({
  text: z.string().min(1),
});
export type TicketChecklistItemAddBody = z.infer<typeof TicketChecklistItemAddBodySchema>;
